
export default {
    path: "/401",
    name: "401",
    meta: { layout: "simple" },
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "home" */ "./PageNotAuthorized.vue")
};
